import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOrganizers } from '@/hooks/useOrganizers';
import { DEFAULT_ORGANIZER_LOGO } from '@/config/constants';
import OrganizersPageView from './organizerspage.view';

const OrganizersPage = () => {
  const navigate = useNavigate();
  const { data: rawOrganizers = [], isLoading: loading } = useOrganizers();

  const organizers = useMemo(() => rawOrganizers.map(org => ({
    id: org.id,
    name: org.name,
    description: org.description,
    logo: org.logo || DEFAULT_ORGANIZER_LOGO,
    website: org.website
  })), [rawOrganizers]);

  return (
    <OrganizersPageView
      organizers={organizers}
      loading={loading}
      navigate={navigate}
    />
  );
};

export default OrganizersPage;
